import React from 'react';
import { Typography } from '@material-ui/core';

const sampleCrudTableColumns = [
  {
    name: 'thumbnail',
    type: 'thumbnail',
    thumbnail: {
      src: 'thumbnail',
      alt: 'text',
    },
    labelId: 'seed.crud.sample.table.thumbnail',
    sorting: false,
  },
  {
    name: 'avatar',
    type: 'avatar',
    avatar: {
      src: 'avatar',
      name: 'text',
      alt: 'text',
    },
    labelId: 'seed.crud.sample.table.avatar',
    sorting: false,
  },
  {
    name: 'text',
    type: 'text',
    labelId: 'seed.crud.sample.table.text',
  },
  {
    name: 'number',
    type: 'number',
    labelId: 'seed.crud.sample.table.number',
  },
  {
    name: 'currency',
    type: 'currency',
    labelId: 'seed.crud.sample.table.currency',
  },
  {
    name: 'dateMonth',
    type: 'dateMonth',
    labelId: 'seed.crud.sample.table.dateMonth',
  },
  {
    name: 'date',
    type: 'date',
    labelId: 'seed.crud.sample.table.date',
  },
  {
    name: 'custom',
    type: 'custom',
    labelId: 'seed.crud.sample.table.custom',
    onRender: (custom) => (
      <Typography color={custom === '1' ? 'primary' : 'error'}>
        {custom === '1' ? 'OK' : 'Not OK'}
      </Typography>
    ),
  },
  {
    name: 'actions',
    type: 'actions',
  },
];

export default sampleCrudTableColumns;
